export default "__VITE_ASSET__CUn56TqS__"